/**
 * Shows/hides the global floating scroll-to-top control after threshold scroll.
 */
(function () {
  'use strict';

  var btn = document.querySelector('[data-platini-global-scroll-top]');
  if (!btn) return;

  var threshold = parseInt(btn.getAttribute('data-scroll-threshold') || '300', 10);
  if (Number.isNaN(threshold) || threshold < 0) threshold = 300;

  var ticking = false;

  function sync() {
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    var show = y > threshold;
    btn.classList.toggle('is-visible', show);
    btn.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) {
      btn.removeAttribute('tabindex');
    } else {
      btn.setAttribute('tabindex', '-1');
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(sync);
    }
  }

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  sync();
})();
